import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../Entity/RequestError";
import {AppThunk} from "../../app/store";
import {Offer} from "../Entity/Offer";
import {postOfferRequestRep} from "../Repository/OfferRequestRepository";
import {CreateAccount} from "../User/Account/CreateAccountTypes";

interface OfferRequestState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: RequestError | null,
  offer: Offer[]|null,
}

const OfferInitialState: OfferRequestState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  offer: null,
  error: null,
}

function startRequest(state: OfferRequestState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.offer = null;
}

function registerFailed(state: OfferRequestState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerSuccess(state: OfferRequestState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.offer = action.payload["hydra:member"] as Offer[];
  state.error = null;
  document.dispatchEvent(new Event("onDatatablesDataReceived"));
}

const OfferRequestSlice = createSlice({
    name: 'offerRequest',
    initialState: OfferInitialState,
    reducers: {
      offerRequestStartRequest: startRequest,
      offerRequestSuccess: registerSuccess,
      offerRequestFailed: registerFailed,
    }
  }
)

export const {
  offerRequestStartRequest,
  offerRequestSuccess,
  offerRequestFailed,
} = OfferRequestSlice.actions;

export default OfferRequestSlice.reducer;

export const submitNewOffer = (offer: Offer, dataCustomerOffer: CreateAccount): AppThunk => async dispatch => {
  try {
    dispatch(offerRequestStartRequest());
    const newsApiResponse = await postOfferRequestRep(offer, dataCustomerOffer);
    dispatch(offerRequestSuccess(newsApiResponse));
  } catch (err) {
    dispatch(offerRequestFailed(err));
  }
}
